<script setup lang="ts">

import {computed, defineProps, onMounted, ref, watch} from "vue";
import {usePlanetStore} from "@/stores/planetStore";
import Backend from "@/models/backend";
import { useGameStore } from '@/stores/gameStore'
import { useI18n } from 'vue-i18n'
import RangeSlider from '@/components/Elements/Forms/RangeSlider.vue'

const { t } = useI18n()

/**
 * Props
 */
const props = defineProps({
  planetId: {
    type: Number,
    required: true
  }
});

/**
 * Stores / models
 */
const planetStore = usePlanetStore()
const gameStore = useGameStore()
const backend = new Backend()

/**
 * Variables
 */
const taxSlider = ref();

/**
 * Computed
 */
const planetData = computed(() => planetStore.findPlanetById(props.planetId)!)

/**
 * Functions
 */
// Function to update sliders based on the current planet data
const adjustTaxSlider = () => {
  backend.updatePlanetTax([props.planetId], taxSlider.value).then(
    () => {
      gameStore.setTinySuccessToastMessage(t('planets.population.settings.taxationUpdated'));
    }
  )
};

/**
 * Watchers
 */
// Watch for changes in planetId and update sliders accordingly
watch(() => props.planetId, (newVal, oldVal) => {
  if (newVal !== oldVal) {
    taxSlider.value = planetData.value.taxPercentage || 0;
  }
}, { immediate: true }); // immediate: true ensures this runs on mount as well


/**
 * Lifecycle
 */
onMounted(() => {
  taxSlider.value = planetData.value.taxPercentage || 0;
});

</script>

<template>
  <img class="hidden md:block w-10 h-10 mr-3 rounded-3xl" :src="'' + gameStore.cdnUrl + 'images/population/64/taxman.webp'" :alt="t('planets.population.settings.taxman')" :title="t('planets.population.settings.taxman')">
  <div class="relative mb-6 flex-grow">
    <RangeSlider
      v-model="taxSlider"
      :min="0"
      :max="100"
      :step="10"
      @update:modelValue="adjustTaxSlider()"
    />
    <span class="text-subtext absolute start-0 -bottom-6">{{ t('planets.population.settings.taxation') }}: <span class="text-metal-300">{{ planetData.taxPercentage }}%</span></span>
  </div>
</template>

<style scoped lang="scss">
.table-td{
  height: 50px !important;
  width: 50px;
}
</style>
